<div class="flex login justify-center h-screen   bg-gray-200   mx-auto z-25 w-full ">
  <div class="flex  md:flex-row flex-wrap justify-center h-min ">
    <div class="md:w-1/2">
      <app-advertisement />
    </div>
    <form [formGroup]="registerForm" *ngIf="!showVerifyRegistrationDialog" class="bg-white shadow-md rounded px-8"
      (ngSubmit)="register()">
      <p class="text-center text-lg text-bold my-5 text-black">Sign Up</p>

      <!-- First Name -->
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block text-black text-sm font-bold mb-2" for="first_name">
            First Name
          </label>
        </div>
        <div class="md:w-2/3 flex-col">
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
            id="first_name" type="text" formControlName="first_name" placeholder="First Name">
          <span class="text-xs text-red-500" *ngIf="firstName?.dirty && firstName?.errors">Invalid First Name</span>
        </div>
      </div>

      <!-- Last Name -->
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block text-black text-sm font-bold mb-2" for="last_name">
            Last Name
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
            id="last_name" type="text" formControlName="last_name" placeholder="Last Name">
          <span class="text-xs text-red-500" *ngIf="lastName?.dirty && lastName?.errors">Invalid Last Name</span>

        </div>
      </div>

      <!-- Email -->
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block text-black text-sm font-bold mb-2" for="email">
            Email <span class="text-xs"> (optional) </span>
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
            id="email" type="email" formControlName="email" placeholder="Email">
          <span class="text-xs text-red-500" *ngIf="email?.dirty && email?.errors">Invalid Email</span>

        </div>

      </div>

      <!-- Phone -->
      <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block text-black text-sm font-bold mb-2" for="phone">
            Phone
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-black leading-tight focus:outline-none focus:shadow-outline"
            id="phone" type="tel" formControlName="phone" placeholder="Phone">
          <span class="text-xs text-red-500" *ngIf="phoneNumber?.dirty && phoneNumber?.errors">Invalid Phone</span>
        </div>
      </div>

      <!-- Password -->
      <!-- <div class="md:flex md:items-center mb-6">
        <div class="md:w-1/3">
          <label class="block text-black text-sm font-bold mb-2" for="password">
            Password
          </label>
        </div>
        <div class="md:w-2/3">
          <input
            class="shadow appearance-none border rounded w-full py-2 px-3 text-black mb-3 leading-tight focus:outline-none focus:shadow-outline"
            id="password" formControlName="password" type="password" placeholder="******************">
        </div>
      </div> -->

      <!-- Submit Button -->
      <div class="md:flex md:items-center">
        <div class="md:w-1/3">
          <button
            class="shadow bg-secondary hover:bg-opacity-70 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
            type="submit">
            Register
          </button>
        </div>
        <div class="md:w-2/3"></div>
      </div>

      <p class="text-black text-center opacity-50">OR</p>
      <a href="" routerLink="/auth"
        class="pt-2 text-center block cursor-pointer hover:underline tracking-wide text-blue-600 text-xs font-bold mb-2">
        Already have an account?
      </a>
    </form>
    <app-otp-verify *ngIf="showVerifyRegistrationDialog" [phoneNumber]="phoneNumber?.value"></app-otp-verify>
    <!-- <form *ngIf="showVerifyRegistrationDialog" [formGroup]="verifyRegistrationForm"
      class="w-full max-w-md bg-white rounded-lg shadow-md px-10 " (ngSubmit)="verifyRegistration()">

      <div class="flex flex-col w-full justify-start my-5">
        <i class=" pi pi-arrow-circle-left hover:bg-opacity-70 focus:shadow-outline font-bold p-2" type="button"
          (click)="showVerifyRegistrationDialog=false">
        </i>
        <p class="text-center text-lg text-bold">Verify Email/Phone Number</p>
      </div>

      <div class="flex flex-wrap -mx-3 mb-6">
        <div class="w-full px-3">
          <label class="block uppercase tracking-wide text-black text-xs font-bold mb-2" for="otp">
            OTP
          </label>
          <input
            class="appearance-none block w-full bg-gray-200 text-black border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white"
            id="otp" type="text" formControlName="otp" placeholder="Enter OTP">
          <div *ngIf="verifyRegistrationForm.get('otp')?.invalid && verifyRegistrationForm.get('otp')?.touched"
            class="text-red-500">
            Please enter the OTP
          </div>
        </div>
      </div>

      <div class="md:flex md:items-center">
        <div class="md:w-1/3">
          <button
            class="shadow bg-secondary hover:bg-opacity-70 focus:shadow-outline focus:outline-none text-white font-bold py-2 px-4 rounded"
            type="submit" [disabled]="verifyRegistrationForm.get('otp')?.invalid">
            Complete Registration
          </button>
        </div>
        <div class="md:w-2/3"></div>
      </div>
    </form> -->
  </div>

</div>